import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewChild,
  Inject,
  forwardRef
} from '@angular/core';

import { 
  FormGroup,
  Validators 
} from '@angular/forms';

import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { isEqual, isNil, isEmpty } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  SeparatorModel,
  ButtonStyles 
} from './models/control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { ToolModel } from './models/tool';
import { TabItemModel, TabGroupModel } from './models/tab';
import { WidgetModel } from './models/widget';
import { FieldsetModel } from './models/fieldset';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { Utilities_ShellService, EModalSize, EToasterType, EToasterPosition } from './Utilities.shell.service';
import { Utilities_OperationService } from './Utilities.operation.service';
import { Utilities_DatasourceService } from './Utilities.datasource.index';
import { Utilities_FlowService } from './Utilities.flow.index';
import { Utilities_ReportService } from './Utilities.report.index';
import { Utilities_LocalizationService } from './Utilities.localization.service';
import { Language } from './localization.service';
import { $types } from './Utilities.types'

import { Utilities_messages_gridComponent } from './Utilities.messages_grid.component';
import { Utilities_logs_gridComponent } from './Utilities.logs_grid.component';
import { Utilities_configurations_gridComponent } from './Utilities.configurations_grid.component';
import { Utilities_applications_dd_singleComponent } from './Utilities.applications_dd_single.component'

@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => Utilities_messages_gridComponent),
    forwardRef(() => Utilities_logs_gridComponent),
    forwardRef(() => Utilities_configurations_gridComponent),
    forwardRef(() => Utilities_applications_dd_singleComponent),
  ],
  selector: 'Utilities-utilities_hub',
  templateUrl: './Utilities.utilities_hub.component.html'
})
export class Utilities_utilities_hubComponent implements OnInit, OnDestroy, OnChanges {

  inParams: { application_name?: string, column_names?: any, filter_values?: any, user_name?: string } = { application_name: null, column_names: null, filter_values: null, user_name: null };
  //#region Inputs
  @Input('application_name') set $inParams_application_name(v: string) {
    this.inParams.application_name = v;
  }
  get $inParams_application_name(): string {
    return this.inParams.application_name;
  }
  @Input('column_names') set $inParams_column_names(v: any) {
    this.inParams.column_names = v;
  }
  get $inParams_column_names(): any {
    return this.inParams.column_names;
  }
  @Input('filter_values') set $inParams_filter_values(v: any) {
    this.inParams.filter_values = v;
  }
  get $inParams_filter_values(): any {
    return this.inParams.filter_values;
  }
  @Input('user_name') set $inParams_user_name(v: string) {
    this.inParams.user_name = v;
  }
  get $inParams_user_name(): string {
    return this.inParams.user_name;
  }
  //#endregion Inputs

  @Input() showInDialog: boolean = false; 
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();  
  //#endregion Outputs
  hasToolbar: boolean = true;



  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  //#endregion
  formGroup: FormGroup = new FormGroup({
    application_name: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });
  
  toolbar = {
      refresh_dropdowns: new ToolModel(new ButtonModel('refresh_dropdowns', new ButtonStyles(['creation'], null), false, 'Refresh dropdowns', 'ms-Icon ms-Icon--Refresh')
    )
  };

  actionbar = {
  };

 filters = {
    application_name: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['application_name'] as DatexFormControl, 
  null, null,
  false, 
  '')
, new ControlContainerStyles(null, null), '', false)
,
  };


  filtersets = {
  application: new FieldsetModel('Application', false, true, true),
};

    rootTabGroup = new TabGroupModel();
  
    subTabGroups = {
    };
  
    onTabSelected(event: MatSelectChange) {
      event.value.activate();
    }
  
    tabs = {
      messages: new TabItemModel(
        this.rootTabGroup, 
        'Messages', 
        ),
      logs: new TabItemModel(
        this.rootTabGroup, 
        'Logs', 
        ),
      configurations: new TabItemModel(
        this.rootTabGroup, 
        'Configurations', 
        ),
    };
  
    //#region tabs inParams
    get $tabs_messages_messages_grid_inParams_application_name(): string {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.application_name.control.value;
      
      return expr;
    }
  
    cacheValueFor_$tabs_messages_messages_grid_inParams_column_names: { number_1?: string, number_2?: string, number_3?: string, number_4?: string, number_5?: string, string_1?: string, string_2?: string, string_3?: string, string_4?: string, string_5?: string };
    get $tabs_messages_messages_grid_inParams_column_names(): { number_1?: string, number_2?: string, number_3?: string, number_4?: string, number_5?: string, string_1?: string, string_2?: string, string_3?: string, string_4?: string, string_5?: string } {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.column_names;
      
      if(!isEqual(this.cacheValueFor_$tabs_messages_messages_grid_inParams_column_names, expr)) {
        this.cacheValueFor_$tabs_messages_messages_grid_inParams_column_names = expr;
      }
      return this.cacheValueFor_$tabs_messages_messages_grid_inParams_column_names;
    }
  
    cacheValueFor_$tabs_messages_messages_grid_inParams_filter_values: { number_1?: number, number_2?: number, number_3?: number, number_4?: number, number_5?: number, string_1?: string, string_2?: string, string_3?: string, string_4?: string, string_5?: string };
    get $tabs_messages_messages_grid_inParams_filter_values(): { number_1?: number, number_2?: number, number_3?: number, number_4?: number, number_5?: number, string_1?: string, string_2?: string, string_3?: string, string_4?: string, string_5?: string } {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.filter_values;
      
      if(!isEqual(this.cacheValueFor_$tabs_messages_messages_grid_inParams_filter_values, expr)) {
        this.cacheValueFor_$tabs_messages_messages_grid_inParams_filter_values = expr;
      }
      return this.cacheValueFor_$tabs_messages_messages_grid_inParams_filter_values;
    }
  
    get $tabs_logs_logs_grid_inParams_application_name(): string {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.application_name.control.value;
      
      return expr;
    }
  
    cacheValueFor_$tabs_logs_logs_grid_inParams_column_names: { number_1?: string, number_2?: string, number_3?: string, number_4?: string, number_5?: string, string_1?: string, string_2?: string, string_3?: string, string_4?: string, string_5?: string };
    get $tabs_logs_logs_grid_inParams_column_names(): { number_1?: string, number_2?: string, number_3?: string, number_4?: string, number_5?: string, string_1?: string, string_2?: string, string_3?: string, string_4?: string, string_5?: string } {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.column_names;
      
      if(!isEqual(this.cacheValueFor_$tabs_logs_logs_grid_inParams_column_names, expr)) {
        this.cacheValueFor_$tabs_logs_logs_grid_inParams_column_names = expr;
      }
      return this.cacheValueFor_$tabs_logs_logs_grid_inParams_column_names;
    }
  
    cacheValueFor_$tabs_logs_logs_grid_inParams_filter_values: { number_1?: number, number_2?: number, number_3?: number, number_4?: number, number_5?: number, string_1?: string, string_2?: string, string_3?: string, string_4?: string, string_5?: string };
    get $tabs_logs_logs_grid_inParams_filter_values(): { number_1?: number, number_2?: number, number_3?: number, number_4?: number, number_5?: number, string_1?: string, string_2?: string, string_3?: string, string_4?: string, string_5?: string } {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.filter_values;
      
      if(!isEqual(this.cacheValueFor_$tabs_logs_logs_grid_inParams_filter_values, expr)) {
        this.cacheValueFor_$tabs_logs_logs_grid_inParams_filter_values = expr;
      }
      return this.cacheValueFor_$tabs_logs_logs_grid_inParams_filter_values;
    }
  
    get $tabs_configurations_configurations_grid_inParams_application_name(): string {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.application_name.control.value;
      
      return expr;
    }
  
    get $tabs_configurations_configurations_grid_inParams_user_name(): string {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.user_name;
      
      return expr;
    }
  
    cacheValueFor_$tabs_configurations_configurations_grid_inParams_column_names: { string_1?: string, string_2?: string, string_3?: string };
    get $tabs_configurations_configurations_grid_inParams_column_names(): { string_1?: string, string_2?: string, string_3?: string } {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.column_names;
      
      if(!isEqual(this.cacheValueFor_$tabs_configurations_configurations_grid_inParams_column_names, expr)) {
        this.cacheValueFor_$tabs_configurations_configurations_grid_inParams_column_names = expr;
      }
      return this.cacheValueFor_$tabs_configurations_configurations_grid_inParams_column_names;
    }
  
    cacheValueFor_$tabs_configurations_configurations_grid_inParams_filter_values: { string_1?: string, string_2?: string, string_3?: string };
    get $tabs_configurations_configurations_grid_inParams_filter_values(): { string_1?: string, string_2?: string, string_3?: string } {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.filter_values;
      
      if(!isEqual(this.cacheValueFor_$tabs_configurations_configurations_grid_inParams_filter_values, expr)) {
        this.cacheValueFor_$tabs_configurations_configurations_grid_inParams_filter_values = expr;
      }
      return this.cacheValueFor_$tabs_configurations_configurations_grid_inParams_filter_values;
    }
  
    //#endregion tabs inParams
  
    //#region tabs children
      @ViewChild('$tabs_messages', { read: Utilities_messages_gridComponent }) $tabs_messages: Utilities_messages_gridComponent;
      @ViewChild('$tabs_logs', { read: Utilities_logs_gridComponent }) $tabs_logs: Utilities_logs_gridComponent;
      @ViewChild('$tabs_configurations', { read: Utilities_configurations_gridComponent }) $tabs_configurations: Utilities_configurations_gridComponent;
    //#endregion tabs children

  //#region filters inParams
  //#endregion filters inParams

  get hubTitle(): string {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `${(($hub.inParams.application_name ?? "") != "") ? `${$hub.inParams.application_name} Hub` : "Utilities Hub"}`;
  }

  get hubDescription(): string {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `This is where we can see messages, logs, and configuration.`;
  }

  constructor(
  private utils: UtilsService,
  private settings: SettingsValuesService,
  private shell: Utilities_ShellService,
  private datasources: Utilities_DatasourceService,
  private flows: Utilities_FlowService,
  private reports: Utilities_ReportService,
  private localization: Utilities_LocalizationService,
  private operations: Utilities_OperationService,
  ) { 
    this.$subscribeFormControlValueChanges();
    this.hasToolbar = !isEmpty(this.toolbar);

    //#region tabs tab init
    this.rootTabGroup.tabs = [
      this.tabs.messages,
      this.tabs.logs,
      this.tabs.configurations,
    ]; 
    //#endregion tabs tab init
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }



  initialized = false;

  async $init() {
    this.title = 'utilities_hub';
    
    const $hub = this;
    const $utils = this.utils;


    await this.on_init();

    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
  }
  close() {
    this.$finish.emit();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = Promise.resolve(null);
    
    // children
    if (skipChildren === false) {
      this.$refreshChildren(childToSkip);
    }

    return result;
  }

  $refreshChildren(childToSkip: string) {
    //#region tabs children
    if (childToSkip !== '$tabs_messages') {
      if (!isNil(this.$tabs_messages) && !this.tabs.messages.hidden) {
        this.$tabs_messages.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$tabs_logs') {
      if (!isNil(this.$tabs_logs) && !this.tabs.logs.hidden) {
        this.$tabs_logs.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$tabs_configurations') {
      if (!isNil(this.$tabs_configurations) && !this.tabs.configurations.hidden) {
        this.$tabs_configurations.refresh(true, false, null);
      }
    }
    //#endregion tabs children
  }

  openImageViewer(imageSource: string) {
    this.shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $hub: Utilities_utilities_hubComponent,
  
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/20/2024
  
  let application_name: string = $hub.inParams.application_name ?? "";
  
  if (application_name.toUpperCase() === "NULL") {
      application_name = "";
  }
  
  if (application_name !== '') {
  
      $hub.filters.application_name.control.value = application_name;
      $hub.title = `${application_name} Hub`;
      $hub.filtersets.application.hidden = true;
  }
  }
  on_refresh_dropdowns(event = null) {
    return this.on_refresh_dropdownsInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_refresh_dropdownsInternal(
    $hub: Utilities_utilities_hubComponent,
  
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
  //O.Arias - 06/20/2024
  
  $flows.Utilities.list_applications({ action: "Refresh" });
  $flows.Utilities.list_processes({ action: "Refresh" });
  $flows.Utilities.list_statuses({ action: "Refresh" });
  $flows.Utilities.list_transaction_types({ action: "Refresh" });
  }
  //#endregion private flows
}
